import type { Ref } from 'vue';
import { computed } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';

import type {
  IDashboardTopsResponse,
} from '../types';
import {
  DASHBOARD_PERMISSIONS,
  DASHBOARD_TOPS_QUERY_KEY,
  DASHBOARD_TOPS_URL,
} from '../constants';

export default function useDashboardTopsQuery(merchant: Ref<number | undefined>): IContextQueryResult<IDashboardTopsResponse, Error> {
  const { fetchGet } = useRestClient();

  return useContextQuery<IDashboardTopsResponse, Error>({
    queryKey: [DASHBOARD_TOPS_QUERY_KEY, merchant],
    queryFn: ({ signal }) => fetchGet(DASHBOARD_TOPS_URL, {
      signal,
      queryParams: { merchant: merchant.value },
      permission: DASHBOARD_PERMISSIONS.DASHBOARD_TOPS,
    }),
    enabled: computed(() => !!merchant.value),
  });
}
